/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { useEffect, useState } from 'react';
import G17Client from '../../services/G17Client';
import { Loader } from '@g17eco/atoms/loader';
import { RequestToJoinForm } from './partials/RequestToJoinForm';
import { CompanyNotAllowed } from './partials/CompanyNotAllowed';
import { BaseStepCompProps, IssuerListItem } from './types';
import SectorInfo from './SectorInfo';
import { ReportingCurrencyForm } from '../onboarding/partials/ReportingCurrencyForm';
import { OnboardingStep } from '../../types/common';

export const IssuerCompanyOnboardOrNot = (props: BaseStepCompProps) => {
  const { formData, stepperStateData } = props;

  const [isLoading, setLoading] = useState(false);
  const [issuer, setIssuer] = useState<IssuerListItem | undefined>();
  const [subStep, setSubStep] = useState<OnboardingStep>(OnboardingStep.SectorInfo);

  useEffect(() => {
    const referralCode = formData.referralCode;
    const issuerId = stepperStateData.issuerId;

    if (!referralCode || !issuerId) {
      return;
    }
    setLoading(true);
    G17Client.getIssuerByReferralCode(referralCode, issuerId)
      .then(setIssuer)
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [formData.referralCode, formData.metadata, stepperStateData.issuerId]);

  const handleNextSubStep = () => {
    setSubStep(OnboardingStep.ReportingCurrency);
  };

  const handlePreviousSubStep = () => {
    setSubStep(OnboardingStep.SectorInfo);
  };

  const renderSubStep = () => {
    switch (subStep) {
      case OnboardingStep.ReportingCurrency:
        return <ReportingCurrencyForm {...props} handlePrevious={handlePreviousSubStep} />;
      default:
      case OnboardingStep.SectorInfo:
        return <SectorInfo {...props} handleNext={handleNextSubStep} />;
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  if (issuer || stepperStateData.customCompanyEnabled) {
    if (issuer?.initiativeId) {
      return <RequestToJoinForm {...props} initiativeId={issuer.initiativeId} />;
    }
    return renderSubStep();
  }

  return <CompanyNotAllowed
    {...props}
    description={'We\'re sorry but SGX ESGenome is just for Singapore Listcos. '+
    'Unfortunately, we don\'t recognise your company name as a Singapore Listco.'}
  />;
}
